import { ANGLE_EPSILON_LOOSE } from "@/helpers/angleConstants";

/** @description Returns the common value if all values in the array are the same, otherwise returns null, which can be used to resolve 'mixed'in a input for example */
export const getCommonNumber = (values: number[]): number | null => {
  const [first] = values;
  if (first === undefined) return null;
  return values.every((value) => Math.abs(value - first) < ANGLE_EPSILON_LOOSE) ? first : null;
};

export const getCommonString = (values: string[]): string | null => {
  const [first] = values;
  if (first === undefined) return null;
  return values.every((value) => value === first) ? first : null;
};

/** @description Returns the common option if all values are equal, otherwise null (e.g. to show 'Mixed' in an input). */
export const getCommonOption = <T extends string>(values: T[]): T | null => {
  const [first] = values;
  if (first === undefined) return null;

  return values.every((value) => value === first) ? first : null;
};

/** @description Returns the common boolean value if all values are the same, otherwise returns null, which can be used to resolve 'mixed' in a input for example */
export const getCommonBoolean = (values: boolean[]): boolean | null => {
  const [first] = values;
  if (first === undefined) return null;
  return values.every((value) => value === first) ? first : null;
};